import {BaseModel} from "../base";

class AdminIntegrationModel extends BaseModel {
    constructor(data) {
        super(data);
    }

    $createImplementation(integrationType, formData) {
        return this.$post('self', {implementation: integrationType}, formData);
    }
}

export {
    AdminIntegrationModel
}